// This code is for the mouse hover events on the li 

const container = document.querySelector('.header__inline-menu ul');

container.addEventListener('mouseover', handleHover);
container.addEventListener('mouseout', handleHover);

function handleHover(event) {
  const navlink = event.target.closest('.first-tier-li');
  if (navlink) {
    const details = navlink.querySelector('details');
    if (details) {
      if (event.type === 'mouseover') {
        details.setAttribute('open', '');
      } else if (event.type === 'mouseout') {
        details.removeAttribute('open');
      }
    }
  }
}

// This Code is for the overflow of when the drawer is getting open 

// const menu_drawer = document.querySelector('#Details-menu-drawer-container');

// menu_drawer.addEventListener('click', handleEvent);

// function handleEvent(event) {
//   if (!this.hasAttribute('open')) {
//     document.querySelector('html').style.overflowY= 'hidden';
//   } else {
//     document.querySelector('html').style.overflowY= 'visible';
//   }
// }
